import { render, staticRenderFns } from "./DriversList.vue?vue&type=template&id=57a4c040&scoped=true"
import script from "./DriversList.vue?vue&type=script&lang=js"
export * from "./DriversList.vue?vue&type=script&lang=js"
import style0 from "./DriversList.vue?vue&type=style&index=0&id=57a4c040&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a4c040",
  null
  
)

export default component.exports